import actionTypes from '../constants'

export const toggleProMemberModal = (showModal = true) => ({
  type: actionTypes.TOGGLE_PRO_MEMBER_MODAL,
  payload: showModal,
})
